import React from 'react'
import { observer } from 'mobx-react'
import _ from 'lodash'
import { LayerGroup } from 'react-leaflet'
import DrawingHandle from './DrawingHandle'
import { turfPointToLatLng } from 'utils'

// Renders handles for every point a user draws in
// the process of drawing a shape.
const ShapeDrawingHandleList = ({ shape }) => (
  <LayerGroup>
    {
      _.map(shape.points, (point, i) => (
        point
          ? (
            <DrawingHandle
              color={shape.getColor}
              position={turfPointToLatLng(point)}
              radius={i === 0 ? 9 : 6}
              key={i}
              zIndexOffset={(i === 0 && shape.closing) ? 1000 : null}
              open={i === 0}
              inactive={!(
                shape.closing &&
                (i === 0 || i === shape.points.length)
              )}
              last={
                (shape.points.length > 0) &&
                (shape.points.length === i + 1)
              }
            />
            )
          : null
      ))
    }
  </LayerGroup>
)

export default observer(ShapeDrawingHandleList)
